import { render, staticRenderFns } from "./salesTemplate.vue?vue&type=template&id=43ec9638&scoped=true"
import script from "./salesTemplate.vue?vue&type=script&lang=js"
export * from "./salesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec9638",
  null
  
)

export default component.exports